var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{on:{"click":_vm.exportPost}},[_vm._v("导出 Excel")])}
var staticRenderFns = []

export { render, staticRenderFns }